import React from 'react';
import { useParams } from 'react-router';
import { Grid } from '@material-ui/core';
import Content from 'src/components/Content';
import useGetRequest from 'src/hooks/useGetRequest';
import EngagementsForContactLedger from './EngagementsForContactLedger';
import Activities from '../../../shared/Activities';

const ViewContact = () => {
  const { accountId } = useParams();

  const { result: contact, isLoading } = useGetRequest({
    url: `/automatic/get-contact-for-account-id/${accountId}/`,
  });

  if (isLoading) return null;

  return (
    <Content title={`View contact: ${contact.account.firstName} ${contact.account.lastName}`}>
      <Grid container spacing={3}>
        <Grid item xs={12} lg={6}>
          <EngagementsForContactLedger contactId={contact.id} accountId={accountId} />
        </Grid>
        <Grid item xs={12} lg={6}>
          <Activities title="Events" url={`/automatic/accounts/${accountId}/events/`} includeEngagementName />;
        </Grid>
      </Grid>
    </Content>
  );
};

export default ViewContact;
